import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Menu.css';

function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000';
      const response = await fetch(`${API_BASE}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: form.username, password: form.password })
      });
      if (response.ok) {
        const data = await response.json();
        console.log('Login response:', data);
        // Save token from response body if present
        if (data && data.token) {
          console.log('Saving token to localStorage:', data.token);
          localStorage.setItem('access_token', data.token);
        } else {
          // Fallback: extract JWT token from cookies
          const cookies = document.cookie.split('; ');
          const accessTokenCookie = cookies.find(row => row.startsWith('access_token='));
          if (accessTokenCookie) {
            const token = accessTokenCookie.split('=')[1];
            console.log('Saving token from cookie:', token);
            localStorage.setItem('access_token', token);
          }
        }
        if (data && data.username) {
          localStorage.setItem('username', data.username);
        }
        navigate('/userlogged');
      } else {
        const errorData = await response.json();
        setError(errorData.detail || 'Login failed.');
      }
    } catch {
      setError('Network error.');
    }
  };

  return (
    <div className="auth-page">
      <h2 style={{ textAlign: 'center' }}>Login</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '20px' }}>
          <label>Username</label>
          <input
            type="text"
            name="username"
            value={form.username}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: '8px', marginTop: '6px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label>Password</label>
          <input
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: '8px', marginTop: '6px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
        </div>
        <button type="submit" style={{ width: '100%', background: '#111', color: '#fff', padding: '10px', border: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '1em', cursor: 'pointer' }}>
          Login
        </button>
        {error && <div className="error-message">{error}</div>}
      </form>
      <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <a href="/register" style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}>
          Register if you don't have account
        </a>
      </div>
    </div>
  );
}

export default Login;
